import { render, staticRenderFns } from "./commodityInformation.vue?vue&type=template&id=4bd216c8&scoped=true"
import script from "./commodityInformation.vue?vue&type=script&lang=js"
export * from "./commodityInformation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bd216c8",
  null
  
)

export default component.exports